import React from "react";
import {FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import "./index.scss";

interface OutputLink {
    id?: string;
    label: string;
    disabled?: boolean;
    icon?: React.ReactElement<FontAwesomeIconProps>
    iconPos?: "left" | "right";
    onClickListener?: () => void;
    href?: string;
    buttonStyle?: boolean;
    variant?: "default" | "grey";
    uppercase?: boolean;
    position?: 'left'
}

export const OutputLink = (props: OutputLink) => {
    const {variant, uppercase, disabled, iconPos, buttonStyle, onClickListener, label, icon, href, position} = props;

    const variantClass = variant ? `output-link_${variant}` : '';
    const uppercaseClass = uppercase ? `output-link_uppercase` : '';
    const disabledClass = disabled ? 'output-link_disabled' : '';
    const iconPosClassName = iconPos ? `output-link_${iconPos}-icon` : 'output-link_right-icon';
    const buttonStyleClass = buttonStyle !== undefined && buttonStyle === true ? 'output-link_button-like' : '';

    const onClick = () => {
        if (disabled) return;

        if (onClickListener) {
            onClickListener();
        }
    };

    const content = 
        <div
            id={props.id}
            className={`output-link ${variantClass} ${uppercaseClass} ${disabledClass} ${iconPosClassName} ${buttonStyleClass}`}
            onClick={onClick}
            style={{ justifyContent: position === 'left' ? 'flex-start': ''}}
        >
            <span className={"output-link__label"}>{label}</span>
            {icon && (
                <span className={"output-link__icon"}>{icon}</span>
            )}
    </div>;

    return (
        <>
            {href && (
                <a href={href}
                   target="_blank"
                   rel="noopener noreferrer"
                   className={"output-link__link"}>
                    {content}
                </a>
            )}

            {!href && (content)}
        </>
    )
};
